import React, { useEffect, useState } from "react";
import {
  DialogActions,
  Button,
  IconButton,
  Grid,
  Paper,
  Select,
  MenuItem,
  Divider,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import { wmsService } from "../../utils/services/wmsProvider";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";

const WMSProviderForm = ({
  selectedClient,
  handleClose,
  selectedData,
  onAddProviderData,
  onDeleteSuccess,
  setLoading,
  providerList,
  viewOnly,
}) => {
  const InitialData = [
    {
      provider: {},
      country: "",
      consignor_name: "",
      company_name: "",
      email: "",
      contact_number: "",
      address1: "",
      address2: "",
      city: "",
      province: "",
      postal: "",
      ior: "",
      // endpoint: '',
      authDetails: [{ key: "", value: "" }],
      provider_details: [{ key: "", value: "" }],
      warehouse_code: "",
    },
  ];
  const [providers, setProviders] = useState(InitialData);
  const [fieldErrors, setFieldErrors] = useState({});

  const handleAddProvider = () => {
    setProviders((prevProviders) => [
      ...prevProviders,
      {
        provider: {},
        providerName: "",
        country: "",
        priority: "",
        consignor_name: "",
        company_nmae: "",
        email: "",
        contact_number: "",
        address1: "",
        address2: "",
        city: "",
        province: "",
        postal: "",
        // endpoint: '',
        authDetails: [{ key: "", value: "" }],
        provider_details: [{ key: "", value: "" }],
        warehouse_code: "",
      },
    ]);
  };

  const handleRemoveProvider = async (index, provider) => {
    setLoading(true);
    if (selectedData?.length) {
      try {
        const wmsResponse = await wmsService.delete(provider?._id);
        if (wmsResponse) {
          onDeleteSuccess && onDeleteSuccess();
          setProviders((prevProviders) =>
            prevProviders.filter((_, i) => i !== index),
          );
          setLoading(false);
          handleClose && handleClose();
        }
      } catch (error) {
        console.error("Delete failed:", error);
        handleClose && handleClose();
      }
    } else {
      setProviders((prevProviders) =>
        prevProviders.filter((_, i) => i !== index),
      );
      setLoading(false);
    }
  };

  const handleChange = (index, field, value) => {
    const selectedData = providerList?.find((x) => x._id === value);

    const newProviders = [...providers];
    newProviders[index][field] = value;
    // Update providers state
    setProviders(newProviders);

    // Validate email or phone format as the user types
    const updatedErrors = { ...fieldErrors };

    if (field === "email") {
      updatedErrors[index] = {
        ...updatedErrors[index],
        email: value && !isValidEmail(value) ? "Invalid email format" : "",
      };
    }

    if (field === "contact_number") {
      updatedErrors[index] = {
        ...updatedErrors[index],
        contact_number:
          value && !isValidPhoneNumber(value)
            ? "Invalid phone number format"
            : "",
      };
    }

    setFieldErrors(updatedErrors);
  };

  const addNewAuthDetails = (e, index) => {
    e.preventDefault();
    const newProviders = [...providers];
    newProviders[index].authDetails = [
      ...(newProviders[index].authDetails || []),
      { key: "", value: "" },
    ];
    setProviders(newProviders);
  };
  const addNewProviderDetails = (e, index) => {
    e.preventDefault();
    const newProviders = [...providers];
    newProviders[index].provider_details = [
      ...(newProviders[index].provider_details || []),
      { key: "", value: "" },
    ];
    setProviders(newProviders);
  };
  const manageAuthDetails = (index, authIndex, field, value) => {
    const newProviders = [...providers];
    newProviders[index].authDetails = newProviders[index].authDetails.map(
      (x, i) => (i == authIndex ? { ...x, [field]: value } : x),
    );
    setProviders(newProviders);
  };
  const manageProviderDetails = (index, authIndex, field, value) => {
    const newProviders = [...providers];
    newProviders[index].provider_details = newProviders[
      index
    ].provider_details.map((x, i) =>
      i == authIndex ? { ...x, [field]: value } : x,
    );
    setProviders(newProviders);
  };
  function isValidConfiguration(config) {
    const requiredFields = [
      "provider",
      "country",
      "consignor_name",
      "company_name",
      "email",
      "contact_number",
      "address1",
      "city",
      "province",
      "postal",
      // 'endpoint',
      "authDetails",
      // "provider_details",
      "name",
      "warehouse_code",
    ];

    return requiredFields.every((field) => config[field] != null);
  }
  useEffect(() => {
    setProviders(
      selectedData.map((x) =>
        x.authDetails?.length && x.provider_details?.length
          ? x
          : {
              ...x,
              authDetails: x.authDetails?.length
                ? [...x.authDetails]
                : [{ key: "", value: "" }],
              provider_details: x.provider_details?.length
                ? [...x.provider_details]
                : [{ key: "", value: "" }],
            },
      ),
    );
  }, [selectedData]);

  async function addConfig(configurations) {
    for (const config of configurations) {
      console.log(config);
      if (isValidConfiguration(config)) {
        if (selectedData?.length) {
          try {
            const response = await wmsService.edit(
              {
                name: config.name,
                provider: config.provider,
                country: config.country,
                consignor_name: config.consignor_name,
                company_name: config.company_name,
                email: config.email,
                contact_number: config.contact_number,
                address1: config.address1,
                address2: config.address2,
                city: config.city,
                province: config.province,
                postal: config.postal,
                id: config.id,
                // endpoint: config.endpoint,
                authDetails: config.authDetails,
                provider_details: config.provider_details,
                warehouse_code: config.warehouse_code,
              },
              config?._id,
            );
            console.log(
              `Successfully added configuration for ${config.provider}`,
            );
            console.log(response.data);
            handleClose && handleClose();
          } catch (error) {
            console.error(
              `Error adding configuration for ${config.provider}:`,
              error.message,
            );
            return;
          }
        } else {
          try {
            // Assuming you have an API endpoint to add configurations
            const response = await wmsService.create(config);
            console.log(
              `Successfully added configuration for ${config.provider}`,
            );
            console.log(response.data);
            handleClose && handleClose(); // Optionally, log the response data
          } catch (error) {
            console.error(
              `Error adding configuration for ${config.provider}:`,
              error.message,
            );
            return;
          }
        }

        setProviders(InitialData);
        onAddProviderData && onAddProviderData();
      } else {
        console.warn("Skipping configuration:", config, "Incomplete fields");
        toast.error("Please provide all required Information!", {
          autoClose: 3000,
        });
        return;
      }
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    addConfig(
      providers.map((item) => ({ ...item, client_id: selectedClient?._id })),
    );
  };

  const removeAuthDetail = (providerIndex, detailIndex) => {
    setProviders((prevState) => {
      const newState = [...prevState];
      if (newState[providerIndex]?.authDetails) {
        newState[providerIndex].authDetails = newState[
          providerIndex
        ].authDetails.filter((_, i) => i !== detailIndex);
      }
      return newState;
    });
  };
  const removeProviderDetail = (providerIndex, detailIndex) => {
    setProviders((prevState) => {
      const newState = [...prevState];
      if (newState[providerIndex]?.provider_details) {
        newState[providerIndex].provider_details = newState[
          providerIndex
        ].provider_details.filter((_, i) => i !== detailIndex);
      }
      return newState;
    });
  };
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhoneNumber = (number) => {
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return phoneRegex.test(number);
  };

  const isFormValid = providers.every((provider) => {
    return (
      provider.provider &&
      provider.consignor_name &&
      provider.company_name &&
      provider.email &&
      provider.contact_number &&
      provider.address1 &&
      provider.address2 &&
      provider.city &&
      provider.province &&
      provider.postal &&
      provider.country &&
      provider.warehouse_code
    );
  });
  return (
    <form onSubmit={handleSubmit}>
      {providers.map((provider, index) => (
        <Paper
          key={index}
          variant="outlined"
          style={{
            backgroundColor: "var(--bg-paper)",
            color: "var(--text-primary)",
            padding: "16px",
            marginTop: "16px",
            background: "var(--hover-bg)",
            borderRadius: "4px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontWeight={500}>{`Provider ${
                index + 1
              }`}</CustomTypography>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              style={{
                // backgroundColor: "var(--bg-paper)",
                color: "var(--text-primary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {selectedData?.length ? (
                <></>
              ) : (
                <IconButton
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    color: "var(--error-red)",
                    padding: 0,
                    background: "var(--error-red)33",
                    height: "30px",
                    width: "30px",
                    borderRadius: "5px",
                    marginLeft: "10px",
                    boxShadow: "0px 0px 4px 0px #00000040",
                    marginTop: "5px",
                  }}
                  aria-label="delete"
                  onClick={() => handleRemoveProvider(index, provider)}
                >
                  <img
                    style={{ height: "15px", width: "15px" }}
                    alt="delete"
                    src="/delete.png"
                  ></img>
                </IconButton>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Provider <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  disabled={viewOnly}
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    marginTop: 5,
                    fontSize: 13,
                    backgroundColor: "var(--bg-paper)",
                    height: 33,
                  }}
                  placeholder="Select Provider"
                  size="small"
                  type="text"
                  value={provider.provider}
                  onChange={(e) =>
                    handleChange(index, "provider", e.target.value)
                  }
                >
                  {providerList.map((data) => (
                    <MenuItem value={data._id} sx={{ height: 30 }}>
                      {data?.name}
                    </MenuItem>
                  ))}
                  {/* <option value="rl">rl</option>
                    <option value="evcargo">evcargo</option> */}
                </Select>
              </div>
            </Grid>

            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Warehouse Code <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Warehouse Code"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.warehouse_code}
                  onChange={(e) =>
                    handleChange(index, "warehouse_code", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Warehouse Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Warehouse Name"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.name}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Consignor Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Consignor Name"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.consignor_name}
                  onChange={(e) =>
                    handleChange(index, "consignor_name", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Company Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Company Name"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.company_name}
                  onChange={(e) =>
                    handleChange(index, "company_name", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Email <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Email"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.email}
                  onChange={(e) => handleChange(index, "email", e.target.value)}
                />
                {fieldErrors[index]?.email && (
                  <span style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {fieldErrors[index].email}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Contact Number <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Contact Number"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.contact_number}
                  onChange={(e) =>
                    handleChange(index, "contact_number", e.target.value)
                  }
                />
                {fieldErrors[index]?.contact_number && (
                  <span style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {fieldErrors[index].contact_number}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Address1 <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Consignor Address1"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.address1}
                  onChange={(e) =>
                    handleChange(index, "address1", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Address2 <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Consignor Address2"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.address2}
                  onChange={(e) =>
                    handleChange(index, "address2", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  City <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="City"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.city}
                  onChange={(e) => handleChange(index, "city", e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Province <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Province"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.province}
                  onChange={(e) =>
                    handleChange(index, "province", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Postal <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Postal"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.postal}
                  onChange={(e) =>
                    handleChange(index, "postal", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  Country <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Country"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.country}
                  onChange={(e) =>
                    handleChange(index, "country", e.target.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "var(--text-primary)",
                  }}
                >
                  IOR <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Importer of Record"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--border-color)",
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13,
                  }}
                  type="text"
                  value={provider.ior}
                  onChange={(e) => handleChange(index, "id", e.target.value)}
                />
              </div>
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontFamily: 'Poppins', fontSize: 13 }}>
                  Endpoint <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  disabled={viewOnly}
                  placeholder="Endpoint"
                  style={{
                    backgroundColor: "var(--bg-paper)",
                    color: "var(--text-primary)",
                    border: '1px solid var(--border-color)',
                    borderRadius: 5,
                    padding: 5,
                    marginTop: 5,
                    fontSize: 13
                  }}
                  type="text"
                  value={provider.endpoint}
                  onChange={(e) => handleChange(index, 'endpoint', e.target.value)}
                />
              </div>
            </Grid> */}
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <label
                style={{
                  fontFamily: "Poppins",
                  fontSize: 13,
                  color: "var(--text-primary)",
                }}
              >
                Provider Details
              </label>

              {provider.provider_details?.map((x, i) => (
                <Grid container spacing={2} key={i} style={{ marginTop: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <label style={{ fontFamily: "Poppins", fontSize: 12, color: "var(--text-primary)" }}>
                      Key <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      disabled={viewOnly}
                      placeholder="Key"
                      style={{
                        backgroundColor: "var(--bg-paper)",
                        color: "var(--text-primary)",
                        border: "1px solid var(--border-color)",
                        borderRadius: 5,
                        padding: 5,
                        marginTop: 5,
                        fontSize: 13,
                        width: "100%",
                      }}
                      type="text"
                      value={x.key}
                      onChange={(e) =>
                        manageProviderDetails(index, i, "key", e.target.value)
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <label style={{ fontFamily: "Poppins", fontSize: 12, color: "var(--text-primary)" }}>
                      Value <span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex", width: "100%" }}>
                      <input
                        disabled={viewOnly}
                        placeholder="Value"
                        style={{
                          backgroundColor: "var(--bg-paper)",
                          color: "var(--text-primary)",
                          border: "1px solid var(--border-color)",
                          borderRadius: 5,
                          padding: 5,
                          marginTop: 5,
                          fontSize: 13,
                          width: "100%",
                        }}
                        type="text"
                        value={x.value}
                        onChange={(e) =>
                          manageProviderDetails(
                            index,
                            i,
                            "value",
                            e.target.value,
                          )
                        }
                      />
                      {viewOnly ? (
                        <></>
                      ) : (
                        <IconButton
                          style={{
                            backgroundColor: "var(--bg-paper)",
                            color: "var(--text-primary)",
                            backgroundColor:
                              i === provider.provider_details.length - 1
                                ? "#DC585C"
                                : "transparent",
                            width: 30,
                            height: 30,
                            borderRadius: "4px",
                            marginLeft: 10,
                            color: "#fff",
                            marginTop: 3,
                          }}
                          onClick={(e) =>
                            i === provider.provider_details.length - 1
                              ? addNewProviderDetails(e, index)
                              : removeProviderDetail(index, i)
                          }
                        >
                          {i === provider.provider_details.length - 1 ? (
                            <AddIcon style={{ color: "#fff" }} />
                          ) : (
                            <DeleteIcon />
                          )}
                        </IconButton>
                      )}
                    </div>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12}>
              <label
                style={{
                  fontFamily: "Poppins",
                  fontSize: 13,
                  color: "var(--text-primary)",
                }}
              >
                Authentication Details
              </label>

              {provider.authDetails?.map((x, i) => (
                <Grid container spacing={2} key={i} style={{ marginTop: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <label style={{ fontFamily: "Poppins", fontSize: 12, color: "var(--text-primary)" }}>
                      Key <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      disabled={viewOnly}
                      placeholder="Key"
                      style={{
                        backgroundColor: "var(--bg-paper)",
                        color: "var(--text-primary)",
                        border: "1px solid var(--border-color)",
                        borderRadius: 5,
                        padding: 5,
                        marginTop: 5,
                        fontSize: 13,
                        width: "100%",
                      }}
                      type="text"
                      value={x.key}
                      onChange={(e) =>
                        manageAuthDetails(index, i, "key", e.target.value)
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <label style={{ fontFamily: "Poppins", fontSize: 12, color: "var(--text-primary)" }}>
                      Value <span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex", width: "100%" }}>
                      <input
                        disabled={viewOnly}
                        placeholder="Value"
                        style={{
                          backgroundColor: "var(--bg-paper)",
                          color: "var(--text-primary)",
                          border: "1px solid var(--border-color)",
                          borderRadius: 5,
                          padding: 5,
                          marginTop: 5,
                          fontSize: 13,
                          width: "100%",
                        }}
                        type="text"
                        value={x.value}
                        onChange={(e) =>
                          manageAuthDetails(index, i, "value", e.target.value)
                        }
                      />
                      {viewOnly ? (
                        <></>
                      ) : (
                        <IconButton
                          style={{
                            backgroundColor: "var(--bg-paper)",
                            color: "var(--text-primary)",
                            backgroundColor:
                              i === provider.authDetails.length - 1
                                ? "#DC585C"
                                : "transparent",
                            width: 30,
                            height: 30,
                            borderRadius: "4px",
                            marginLeft: 10,
                            color: "#fff",
                            marginTop: 3,
                          }}
                          onClick={(e) =>
                            i === provider.authDetails.length - 1
                              ? addNewAuthDetails(e, index)
                              : removeAuthDetail(index, i)
                          }
                        >
                          {i === provider.authDetails.length - 1 ? (
                            <AddIcon style={{ color: "#fff" }} />
                          ) : (
                            <DeleteIcon />
                          )}
                        </IconButton>
                      )}
                    </div>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Paper>
      ))}
      <div
        style={{
          // backgroundColor: "var(--bg-paper)",
          color: "var(--text-primary)",
          marginTop: "16px",
          width: "100%",
          justifyContent: "flex-end",
          display: "flex",
        }}
      >
        {selectedData?.length ? (
          <></>
        ) : (
          <Button onClick={handleAddProvider} style={{ textTransform: "none" }}>
            <CustomTypography
              fontSize={"14px"}
              color={"var(--primary-blue)"}
              fontWeight={400}
            >{`+ Add Provider`}</CustomTypography>
          </Button>
        )}
      </div>

      <DialogActions style={{ padding: "16px" }}>
        <Button
          style={{
            backgroundColor: "var(--bg-paper)",
            color: "var(--text-primary)",
            fontSize: "12px",
            fontFamily: "Poppins",
            textTransform: "none",
          }}
          onClick={handleClose}
          variant="outlined"
        >
          Cancel
        </Button>
        {viewOnly ? (
          <></>
        ) : (
          <Button
            style={{
              backgroundColor: "var(--bg-paper)",
              color: "var(--text-primary)",
              fontSize: "12px",
              fontFamily: "Poppins",
              textTransform: "none",
            }}
            type="submit"
            variant="contained"
            color="primary"
            disabled={!isFormValid}
          >
            Add
          </Button>
        )}
      </DialogActions>
    </form>
  );
};

const WMSProviderModal = ({
  setOpen,
  onClose,
  selectedClient,
  selectedData,
  onAddProviderData,
  setLoading,
  loading,
  onDeleteSuccess,
  providerList,
  viewOnly,
}) => {
  const handleClose = () => {
    setOpen(false);
    onClose && onClose();
  };

  return (
    <WMSProviderForm
      viewOnly={viewOnly}
      onDeleteSuccess={onDeleteSuccess}
      setLoading={setLoading}
      loading={loading}
      onAddProviderData={onAddProviderData}
      selectedData={selectedData}
      handleClose={handleClose}
      selectedClient={selectedClient}
      providerList={providerList}
    />
  );
};

export default WMSProviderModal;
